module.exports = __webpack_public_path__ + "img/four2Blue.84a1eb27.png";